import React from 'react'
import './sytle.css'

export const Home = () => {

  return (
    <div className='div-container'>
        <h1>
            <span className='estiven'>Estiven</span>
            <span className='Mahecha'>Mahecha</span>
            <span className='Henao'>Henao</span>
        </h1>
    </div>
  )
}
